import { useMemo } from 'react';
import useValidator from '../../../utilities/useValidator';
import validators from '../../../utilities/validators';

const useLanguagePackValidator = () => {
    const validator = useMemo(
        () => validators.compose(validators.requiredString('referenceName'), validators.requiredString('displayName')),
        []
    );

    return useValidator(validator);
};

export default useLanguagePackValidator;
